
let template = '';

$(function() {

    console.log("custom.js v1.1");
    
    if($("body").hasClass("template-cart")){
      renderContainers();
    } else {
          console.log("no hay template-cart");
    }

    
    /*
    console.log("sessionId: " + localSessionId);
    console.log("remoteSessionId: " + remoteSessionId);

    if(!remoteSessionId && customer && customer != ""){
        console.log("no remote session id");
        const attributes = {
            attributes: {
                remoteSessionId: localSessionId
            }
        };
        updateCartAttribute(attributes, function(data){
            console.log("updateCartAttribute callback");
            console.log(data);
            document.body.classList.add("loading");
            fetch(`https://sempertex-cross-cart.fly.dev/api/v1/cart/${customer}`, {
                method: 'GET',
                headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                },
            })
            .then(response => response.json())
            .then(data => {
                
                console.log('Items:', data)
                if(data != null){
                    location.href = '/pages/redirect';
                } else {
                    document.body.classList.remove("loading");
                }
            });
        });
    }

    console.log("first_request", first_request);
    */
    console.log("first_request", first_request);
  
    if(request_host.includes('durpets.com') && request_path !== '/pages/dur' && first_request == ""){
      console.log("durpets.com");

      let attributes = {
        attributes: {
          first_request: "true"
        }
      };

      console.log("redirect");
      location.href = '/pages/dur';

      /*
      updateCartAttribute(attributes, function(data){
        console.log(data);
        location.href = '/pages/home-naval';
      });
      */
    }

    $(document).on('click', '#cartCheckoutWithValidation', function(){
        fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                $("#cartCheckout").click();
                return

                //Deshabilitado control carrito
                console.log("cart.js");
                console.log(data);

                let cart_total = data.total_price / 100;

                if(cart_total >= min_cart_value){
                    //onsole.log("cart total greater than min cart value");
                    $("#cartCheckout").click();
                } else {
                    let formatted_min_cart_value = min_cart_value.toLocaleString('es-CO', {style: 'currency', currency: 'COP'});
                    //remove decimals
                    formatted_min_cart_value = formatted_min_cart_value.substring(0, formatted_min_cart_value.length - 3);
                    Swal.fire({
                        icon: 'error',
                        text: 'No se puede realizar la compra, su pedido deberá ser mínimo de' + formatted_min_cart_value + ' Pesos IVA Incluido'
                    })
                }
            });
    });

    $(document).on("click", ".reorder-btndsd", function(){
        console.log("click reorder");
        let order = $(this).attr("data-order");
        console.log(order);

        $.ajax({
            url: `/pages/order/_oid=${order}?view=order-detail`,
              dataType: 'html',
              type: 'GET',
              success: function(data){
                console.log(data);
              },
              error: function(data){console.log('ajax error')},
              complete: function(){}
        });
    });

    $(document).on("click", ".reorder-products-btn", function(){
        $.magnificPopup.close();
        $("body").addClass("loading");
        let order = $(this).attr("data-order");
        console.log(order);
        //iterate all checkboxs that are checked with specific name order
        let items = [];
        $("input[name='reorderChk" + order + "']:checked").each(function(){
            let variant_id = $(this).attr("data-variant-id");
            let quantity = $("#qty_" + variant_id).val();

            items.push({
                id: variant_id,
                quantity: quantity
            });
        });

        console.log("items: ");
        console.log(items);

        //add items to cart
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                items: items
            },
            dataType: 'json',
            success: function(cart) {
                console.log("success");
                console.log(cart);

                // let event = new CustomEvent('item:added',{
                //     bubbles: true,
                //     cancelable: true
                // });
                // document.dispatchEvent(event);
                
                //close magnific popup
                $("body").removeClass("loading");
                
                //redirect to cart page
                window.location.href = "/cart";
            }
        });
    });

    $(document).on('click', '.remove_all_items', function(){
        $("body").addClass("loading");
        $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function(cart) {
                $("body").removeClass("loading");
                
                let event = new CustomEvent('item:added',{
                    bubbles: true,
                    cancelable: true
                });
                document.dispatchEvent(event);

                location.reload();
            }
        });
    });

    $(document).on('click', '.btn-show-variants', function(){
        var variant_row_id = $(this).attr('data-variants-row');
        $("."+variant_row_id).toggle();
    });

    $(document).on('click', '.cart_row_flex_button_toggle', function(){
        let variant_id = $(this).attr('data-id');
        
        $(".cart_row_flex_variants_"+variant_id).slideToggle();

        $(this).children("i").toggleClass('at-plus-l at-minus-l');
        
    });

    //add listener for "item:added" event
    document.addEventListener('item:added', function(e) {
        console.log("Added to cart");
        console.log(e);
        console.log('customer: ' + customer);
        // console.log("cart: ");
        // console.log(CartJS.cart.items);

        if(customer && customer != ""){

            //fetch cart.js
            fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
                console.log("cart.js");
                console.log(data);

                var items = [];

                boxes = 0;

                for(let i = 0; i < data.items.length; i++){
                    let item = data.items[i];
                    let itemObj = {
                        id: item.id,
                        title: item.title,
                        variant_id: item.variant_id,
                        product_id: item.product_id,
                        feature_image: item.featured_image.url,
                        quantity: item.quantity,
                        price: item.price,
                        handle: item.handle,
                        variant_title: item.variant_title
                    };

                    items.push(itemObj);

                    if ($("body").hasClass("template-cart")) {
                        console.log("hear");
                        let key = item.key.replace(/:/g, '\\:');;
                        let updateEl = $("#updates_" + key);
                        if(updateEl){
                            let step = updateEl.attr("data-step");
                            console.log("step: " + step);
                            if(step){
                              let box = item.quantity / step;
                              let boxes_message = box > 1 ? `${box} ${box_plural}` : `${box} ${box_singular}`;
                              $("#boxes_" + item.variant_id).text(boxes_message);
                              boxes += box;
                            }
                        }
                    }
                }

                let wrapper = {
                    customer: customer,
                    cart: items
                };
    
                console.log("wrapper: ");
                console.log(wrapper);

                renderContainers();

                if ($("#boxes").length > 0) {
                    $("#boxes").text(boxes);
                    let pallets = Math.ceil(boxes / boxes_by_pallet);
                    $("#pallets").text(pallets);
                }
    
                //post object to server https://shopifydev.gomonke.com/api/v1/cart
                $.ajax({
                    type: 'POST',
                    url: 'https://sempertex-cross-cart.fly.dev/api/v1/cart',
                    data: JSON.stringify(wrapper),
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function(result) {
                        console.log("success");
                        console.log(result);
                    }
                });
                
            });
            
        }

    
    });

});

function renderContainers() {
    if ($("body").hasClass("template-cart")) {
        let contenedores = [];
    
        fillContainers(boxes, contenedores);
    
        console.log('Containers llenados');
        console.table(contenedores);
    
        //remove all containers
        document.querySelector('.containers-pane').innerHTML = '';
    
    
        //create elements like 'container-row' each contains
        for (let i = 0; i < contenedores.length; i++) {
            const container = contenedores[i];
            let container_row = document.createElement('div');
            container_row.classList.add('freight-row');
            container_row.classList.add('container-row');
    
            let container_icon = document.createElement('div');
            container_icon.classList.add('freight-icon');
    
            let container_icon_img = document.createElement('img');
            container_icon_img.src = 'https://cdn.shopify.com/s/files/1/0556/3560/7615/files/container.png?v=1702346922';
            container_icon.appendChild(container_icon_img);
    
            let container_thermometer = document.createElement('div');
            container_thermometer.classList.add('thermometer-container');
    
            let container_thermometer_name = document.createElement('span');
            container_thermometer_name.id = 'thermometer_name';
            container_thermometer_name.textContent = container.container;
            container_thermometer.appendChild(container_thermometer_name);
    
            let freight_thermometer = document.createElement('div');
            freight_thermometer.classList.add('freight-thermometer');
    
            let container_thermometer_fill = document.createElement('div');
            container_thermometer_fill.id = 'thermometer-fill';
            container_thermometer_fill.style.width = ((container.occupation * 100) / container.boxes) + '%';
            freight_thermometer.appendChild(container_thermometer_fill);
            
            container_thermometer.appendChild(freight_thermometer);
    
            let container_thermometer_total = document.createElement('span');
            container_thermometer_total.id = 'thermometer_total';
            container_thermometer_total.textContent = box_plural + ": " + container.occupation + ' / ' + container.boxes;
            container_thermometer.appendChild(container_thermometer_total);
    
            container_row.appendChild(container_icon);
            container_row.appendChild(container_thermometer);
    
            document.querySelector('.containers-pane').appendChild(container_row);
        }
    } else {
      console.log("no hay template-cart");
    }
}

function fillContainers(total_boxes, containers) {
    let required_container = containers_table.filter(container => total_boxes <= container.boxes);

    if(required_container.length == 0){
        let last_container = containers_table[containers_table.length - 1];
        let max_container_boxes = last_container.boxes;
        containers.push({
            container: last_container.container,
            boxes: last_container.boxes,
            occupation: max_container_boxes
        });
        fillContainers(total_boxes - max_container_boxes, containers);

    } else {
        let container = containers_table.filter(container => total_boxes <= container.boxes)[0];
        containers.push({
            container: container.container,
            boxes: container.boxes,
            occupation: total_boxes
        });
    }
}

function updateCartAttribute(params, callback){
   //fetch update.js
    fetch('/cart/update.js', {
     method: 'POST',
     headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
     },
     body: JSON.stringify(params)
    }).then(response => response.json())
    .then(data => {
        console.log("update.js");
        console.log(data);
        callback(data);
    });
}